module.exports = __webpack_public_path__ + "img/mapBanner.af2131ce.png";